import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { bool, func, node } from "prop-types";

import { useDrawerContext } from "../../utilities/drawerHelpers";
import ContactBox from "../ContactBox";
import DrawerButtons from "../DrawerButtons";
import * as S from "./styled";

const Step = ({ children, isModal, onCancel, showDrawerButtons }) => {
  const [step, setStep] = useState(React.Children.only(children));

  const [stepInfo, setStepInfo] = useState({
    cancelText: "Cancel",
    hasCancelOnMobile: false,
    submitText: "Submit"
  });
  const formikContext = useFormikContext();
  const hasDrawerForm = useDrawerContext();

  useEffect(() => {
    setStepInfo({
      cancelText: step.props.cancelText ?? "Cancel",
      hasCancelOnMobile: step.props.hasCancelOnMobile ?? false,
      header: step.props.contactHeader,
      submitText: step.props.submitText ?? "Submit"
    });
  }, [step]);

  useEffect(() => {
    setStep(React.Children.only(children));
  }, [children]);

  const handleCancel = async () => {
    if (step.props.onCancel && step.props.fieldToCancel) {
      const submission = await step.props.onCancel(formikContext);

      if (submission?.error) {
        return false;
      }
    }

    return onCancel();
  };

  return (
    <>
      <ContactBox header={stepInfo.header} isModal={isModal}>
        <S.StepWrapper $hasDrawerForm={hasDrawerForm}>{step}</S.StepWrapper>
      </ContactBox>
      {showDrawerButtons && (
        <DrawerButtons
          cancelText={stepInfo.cancelText}
          hasCancelOnMobile={stepInfo.hasCancelOnMobile}
          onCancel={handleCancel}
          submitText={stepInfo.submitText}
        />
      )}
    </>
  );
};

Step.propTypes = {
  children: node.isRequired,
  isModal: bool,
  onCancel: func,
  showDrawerButtons: bool
};

Step.defaultProps = {
  isModal: false,
  onCancel: () => true,
  showDrawerButtons: true
};

export default Step;
